import { ChangeEvent } from "react";
import { WaitTimeGroup } from "../../models";
import { InputNumber } from "../Common";

interface WaitTimeGroupsTableProps {
	settingValue: string;
	onChange: (event: ChangeEvent<HTMLInputElement>) => Promise<void>;
}

export const WaitTimeGroupsTable = ({
	settingValue,
	onChange
}: WaitTimeGroupsTableProps) => {
	const waitTimeGroups: WaitTimeGroup[] = JSON.parse(settingValue);

	return (
		<table className="ch-table w-full max-w-[360px] border-collapse">
			<thead>
				<tr>
					<th>Label</th>
					<th>Lower limit</th>
					<th>Upper limit</th>
				</tr>
			</thead>
			<tbody>
				{waitTimeGroups.map((group, index) => (
					<tr key={`group-${group.name}`}>
						<td>{group.name}</td>
						<td>
							<InputNumber
								value={group.min || ""}
								name={`${group.name}-min`}
								handleChange={onChange}
								min={0}
								width={100}
							/>
						</td>
						<td>
							{index < 2 && (
								<InputNumber
									value={group.max || ""}
									name={`${group.name}-max`}
									handleChange={onChange}
									min={0}
									width={100}
								/>
							)}
						</td>
					</tr>
				))}
			</tbody>
		</table>
	);
};
